export function WhiteContainer({ children, className = "" }) {
  return (
    <div className={`flex min-h-48 w-full max-w-[550px] flex-col overflow-y-auto rounded-2xl bg-white px-4 py-3 sm:max-w-[700px] lg:min-h-0 ${className}`}>
      {children}
    </div>
  )
}
